import { kExpandedSidebarWidth } from "../../../@core/config/LayoutConstraints";
import { EXPAND_SIDEBAR } from '@src/redux/statusTypes'

export default {
  sidebarWidth: kExpandedSidebarWidth,
  mode: EXPAND_SIDEBAR
}